<template>
  <div class="master-toko">
    <div class="section">
      <header-page>
        <span class="size14 fw-bold-700" style="color: #0b5fff; margin-right: 5px">Master</span>
        <span class="text-dark text-darken-5" style="margin-right: 5px">></span>
        <span class="text-dark fw-bold-400 size14">Credit Subscription</span>
      </header-page>

      <TableCreditSubscription />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { BContainer, BButtonGroup, BButton } from "bootstrap-vue";
import TableCreditSubscription from "@/components/CreditSubscription/TableCreditSubscription.vue";

import HeaderPage from "@/components/HeaderPage.vue";

export default {
  title() {
    return "Master Billing";
  },
  components: {
    BContainer,
    BButtonGroup,
    BButton,
    HeaderPage,
    TableCreditSubscription
  },
  data() {
    return {
      // comp: "TableBilling",
      // tabFilter: "Toko Utama",
      listFilter: ["Toko Utama", "Tambahan"],
      filter: "Toko Utama",
      comp: "TableBilling",
    };
  },
  mounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.master-toko {
  button.bg-white {
    &:focus {
      background-color: transparent !important;
    }
  }
}
</style>
